var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39383 0.436035C0.659364 0.436035 0.0639648 1.03143 0.0639648 1.7659V9.74506C0.0639648 10.4795 0.659364 11.0749 1.39383 11.0749H9.37299C10.1075 11.0749 10.7029 10.4795 10.7029 9.74506V1.7659C10.7029 1.03143 10.1075 0.436035 9.37299 0.436035H1.39383ZM1.12785 1.7659C1.12785 1.619 1.24693 1.49992 1.39383 1.49992H9.37299C9.51989 1.49992 9.63896 1.619 9.63896 1.7659V9.74506C9.63896 9.89196 9.51989 10.011 9.37299 10.011H1.39383C1.24693 10.011 1.12785 9.89196 1.12785 9.74506V1.7659Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39383 1.49992C1.24693 1.49992 1.12785 1.619 1.12785 1.7659V9.74506C1.12785 9.89196 1.24693 10.011 1.39383 10.011H9.37299C9.51989 10.011 9.63896 9.89196 9.63896 9.74506V1.7659C9.63896 1.619 9.51989 1.49992 9.37299 1.49992H1.39383ZM8.68606 4.53498C8.89334 4.32679 8.89262 3.98998 8.68443 3.78269C8.47625 3.57541 8.13944 3.57613 7.93215 3.78432L4.86291 6.86683L3.09718 5.12568C2.888 4.9194 2.5512 4.92176 2.34492 5.13095C2.13864 5.34014 2.141 5.67694 2.35019 5.88321L4.49285 7.99605C4.70132 8.20162 5.03672 8.20009 5.2433 7.99262L8.68606 4.53498Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.244b23b704ea121476b9ea96d581b0b8.svg";
export { ForwardRef as ReactComponent };